const defaultConfig = {
  generalSettings: {
    baseCurrency: {
      visible: true,
    },
    lineSuggestions: {
      visible: true,
    },
  },
  sequences: {
    visible: true,
  },
};

export const accountConfig = {
  default: {
    ...defaultConfig,
  },
  usa: {
    ...defaultConfig,
    generalSettings: {
      baseCurrency: {
        visible: false,
      },
      lineSuggestions: {
        visible: false,
      },
    },
    sequences: {
      visible: false,
    },
  },
};
